<template>
  <b-container fluid="sm" class="my-sm-2 px-0">
    <b-row class="justify-content-center align-self-center">
      <b-col cols="12" sm="6">

        <b-form>
          <div v-if="calcType" class="main rounded-lg shadow-sm">
            <h5 class="mb-4 mt-3 main-title">John's Running Calculator</h5>
            <b-tabs v-model="tabIndex" content-class="mt-3" pills small @input="onTabChange" class="compact-tabs">
              <b-tab v-for="opt in options" :key="opt.value" :title="opt.name" :title-item-class="'tab-item'">
                <template #title>
                  <span v-b-tooltip.hover.d500 :title="opt.text">{{ opt.name }}</span>
                </template>
                <h6 class="mt-3 mx-3">{{opt.name}}</h6>
                <p class="description mx-3">{{ opt.text }}</p>
                <div id="calculator">
                  <keep-alive>
                    <component :is="opt.component"></component>
                  </keep-alive>
                </div>
              </b-tab>
            </b-tabs>
          </div>

        </b-form>
      </b-col>
    </b-row>

  </b-container>

</template>
<script>

import PaceCalculator from './components/PaceCalculator'
import TimeCalculator from './components/TimeCalculator'
import DistanceCalculator from './components/DistanceCalculator'
import Conversions from './components/Conversions'
import UnitConverter from "./components/UnitConverter";
import PaceConverter from "./components/PaceConverter";
import HeartRate from "./components/HeartRate";
import AgeGradingCalculator from "./components/AgeGradingCalculator";
import PercentageChangesCalculator from "./components/PercentageChangesCalculator";

export default {
  components: {
    PaceCalculator, TimeCalculator, DistanceCalculator,Conversions,UnitConverter,PaceConverter,HeartRate,AgeGradingCalculator,PercentageChangesCalculator
  },

  data: () => ({
    calcType: 'pace',
    tabIndex: 0,
    options: [
      //{value: null, text: "Select calculator..."},
      {value: 'pace', name:"Pace Calculator",text: 'Enter distance and target time to get required pace',component:PaceCalculator,path:"/pace"},
      {value: 'time', name:"Time Calculator", text: 'Enter pace and distance to get total time',component:TimeCalculator,path:"/time"},
      {value: 'distance', name:"Distance Calculator", text: 'Enter pace and time to get distance run',component:DistanceCalculator,path:"/distance"},
      {value: 'ageGrading', name:"Age Grading Calculator", text: 'Calculate your age grading from a race time',component:AgeGradingCalculator,path:"/age-grading"},
      {value: 'conversions', name:"Pace-Speed Converter", text: 'Convert between pace and speed',component: Conversions,path:"/conversions"}
      ,
      {value: 'percentage-changes', name:"Percentage Changes Calculator", text: 'Increase or decrease pace or speed by an amount',component: PercentageChangesCalculator,path:"/percentage-changes"}
      ,
      {value: 'unit-converter', name:"Miles <-> Kilometres", text: 'Convert between miles and kilometres',component: UnitConverter,path:"/unit-converter"},
      {value: 'pace-converter', name:"Mins/mile <-> Mins/km", text: 'Convert pace between mins/miles and mins/km',component: PaceConverter,path:"/pace-converter"},
      {value: 'heart-rate-percentages', name:"Heart Rate Percentages", text: 'Display heart rate training percentages',component: HeartRate,path:"/heart-rate"},
    ],

  }),
  computed: {
    description(){
      return this.options.find(x => x.value=== this.calcType).text;
    },
    component(){
      return this.options.find(x => x.value=== this.calcType).component;
    }
  },
  mounted() {
    // Initialize tabIndex based on calcType
    const initialIndex = this.options.findIndex(opt => opt.value === this.calcType);
    if (initialIndex !== -1) {
      this.tabIndex = initialIndex;
    }
  },
  methods: {
    logType() {
      console.log("Type selected = " + this.calcType);
    },
    onTabChange(index) {
      this.tabIndex = index;
      if (this.options[index]) {
        this.calcType = this.options[index].value;
        this.logType();
      }
    }
  }

}

</script>
<style type="text/scss">
body{
  background-color: #eeeeee;
}

.tab-pane{
  border: 1px dotted white;
}

.description{
  font-size: 0.9rem;
  line-height: 1.2;
  color: saddlebrown;
}
.main-title{
  font-size: 1.5rem;
  color:darkgreen;
}

.main{
  background-color: lightblue;
  padding:20px;
  border: solid 2px silver;
  min-height:95vh;
}

#selector{
  color:teal;
  font-size: 1rem;
 margin-bottom:0;
}

#calculator{

  padding: 0.75rem;

}

.instruction {
  font-size:18px;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 0.5em;
  color:teal;
}

.small-lbl {
  font-size: 14px;
}

.result{
  font-size:18px;

}
.form-control.is-valid,
.form-control.is-invalid {
  background-image: none;
  padding-right: 0;
}

.compact-tabs .nav-pills .nav-link {
  padding: 0.2rem 0.45rem;
  font-size: 0.8rem;
  margin-right: 0.2rem;
  margin-bottom: 0.2rem;
  background-color: rgba(255, 255, 255, 0.6);
  color: teal;
  border: 1px solid rgba(0, 128, 128, 0.4);
  line-height: 1.3;
}

.compact-tabs .nav-pills .nav-link:hover {
  background-color: rgba(255, 255, 255, 0.8);
  color: darkgreen;
  border-color: rgba(0, 100, 0, 0.6);
}

.compact-tabs .nav-pills .nav-link.active {
/*  background-color: darkgreen;
  color: white;
  border-color: darkgreen;
  display:none;*/
  color: rgba(255, 255, 255, 0.6);
  background-color: teal;
}

.compact-tabs .nav-pills {
  margin-bottom: 0.35rem;
}


</style>